import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FylkerOverviewPage } from './overview';
import { FylkePage } from './fylke';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: FylkerOverviewPage },
      { path: ':fylke', component: FylkePage }
    ])
  ]
})
export class FylkerRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+fylker/routing.ts